import React from "react";
import PropTypes from "prop-types";


export default function TemplateGrid({ templates, selectedTemplateId, onSelect }) {
  return (
    
     <div className="flex flex-row gap-2 ">
      {templates.map((template) => {
         const isSelected = selectedTemplateId === template.id;
         return (
            <div
            key={template.id}
            onClick={() => onSelect(template.id)}
            className={`w-[198px] flex flex-col items-start justify-between cursor-pointer rounded-[20px] h-[156px] border py-[14px] px-[12px] flex flex-col gap-2 transition relative bg-[#1B5C291A] ${
                isSelected
                ? "border-[#1B5C29] border ring-0"
                : "border-[#E0E0E0] hover:border-[#BDBDBD] hover:bg-gray-50"
            }`}
            >
             <div className="w-full aspect-video rounded bg-gray-100 overflow-hidden relative border border-gray-100">
                 <img src={template.images[0]} alt="" className="w-full h-full object-cover" />
            </div>
            <div className="flex items-center justify-between px-2">
                <span className={`text-[14px] font-medium leading-tight ${isSelected ? "text-[#333333]" : "text-[#333333]"}`}>
                {template.label}
                </span>
            </div>
            </div>
        );
      })}
    </div>
  );
}

TemplateGrid.propTypes = {
  templates: PropTypes.array.isRequired,
  selectedTemplateId: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};
